import type { ReactNode } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'

/** In-app confirmation (replaces the browser's window.confirm). */
export function ConfirmDialog({
  open,
  title,
  children,
  confirmLabel = 'Confirm',
  destructive = false,
  onConfirm,
  onCancel,
}: {
  open: boolean
  title: string
  children: ReactNode
  confirmLabel?: string
  destructive?: boolean
  onConfirm: () => void
  onCancel: () => void
}) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth aria-labelledby="onboarding-confirm-title">
      <DialogTitle id="onboarding-confirm-title" sx={{ fontSize: 18, fontWeight: 600, color: '#0f172a' }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 14, lineHeight: 1.6, color: '#334155' }}>{children}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button type="button" variant="outlined" onClick={onCancel} sx={{ borderColor: '#cbd5e1', color: '#334155' }}>
          Cancel
        </Button>
        <Button
          type="button"
          variant="contained"
          color={destructive ? 'error' : 'primary'}
          onClick={onConfirm}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
